import { LocationType } from '~/client/graph'
import Localization from '~/client/src/shared/localization/LocalizationManager'
import GlobeView from '~/client/src/shared/models/GlobeView'
import Sitemap from '~/client/src/shared/models/Sitemap'
import LocationAttributesStore from '~/client/src/shared/stores/domain/LocationAttributes.store'

const SCOPE_SEPARATOR = ', '
const PARTS_SEPARATOR = ' · '

interface IBuildMapViewSubtitleArgs {
  globe?: GlobeView
  sitemap?: Sitemap
  locationAttributesStore: LocationAttributesStore
}

export function buildMapViewSubtitle(args: IBuildMapViewSubtitleArgs): string {
  const scope = resolveScopeLabel(args)
  const capability = resolveCapabilityLabel(args)
  return `${scope}${PARTS_SEPARATOR}${capability}`
}

function resolveScopeLabel({
  globe,
  sitemap,
  locationAttributesStore,
}: IBuildMapViewSubtitleArgs): string {
  const mapId = globe?.id || sitemap?.id
  if (!mapId) return Localization.translator.project

  const isGlobe = !!globe
  const owners = locationAttributesStore.allAttributes.filter(attr => {
    const ids = isGlobe ? attr.assignedGlobes : attr.assignedSitemaps
    return ids?.includes(mapId)
  })

  const meaningfulOwners = owners.filter(
    owner => owner.type !== LocationType.ProjectLocation,
  )

  if (!meaningfulOwners.length) return Localization.translator.project

  return meaningfulOwners.map(owner => owner.name).join(SCOPE_SEPARATOR)
}

function resolveCapabilityLabel({
  globe,
  sitemap,
}: IBuildMapViewSubtitleArgs): string {
  const georeferenced = Localization.translator.georeferenced
  const nonGeoreferenced = Localization.translator.nonGeoreferenced
  // Globe-first to match title resolution; reading sitemap first when both are set
  // would contradict the title.
  if (globe) {
    const isGeoreferenced = !!globe.bounds || !!globe.center
    return isGeoreferenced ? georeferenced : nonGeoreferenced
  }

  if (sitemap) {
    return sitemap.isReferenced ? georeferenced : nonGeoreferenced
  }

  return nonGeoreferenced
}
